import GSMM from "./GSMM";
import PSMH from "./PSMH";
import GPRU from "./GPRU";
import GDEN from "./GDEN";

// Plans ----------------------
const plans = [GSMM, PSMH, GPRU, GDEN];

export default plans;
